module.exports = __webpack_public_path__ + "img/franchising_accomplishments_2.3c5b3fa4.svg";